import React, { useState } from "react";
import { toast } from 'react-toastify';
import JsCodeEditor from "../../../components/JsCodeEditor";

const SettingTab = ({ handleLayoutChange, selectedLayout,updateAnnouncementBarTabData,announcementBarTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [displayPagesType, setDisplayPagesType] = useState(announcementBarTabData.display_page_type);
    const [hidePagesType, setHidePagesType] = useState(announcementBarTabData.hide_page_type);
    const [visibilityOnDevicesType, setVisibilityOnDevicesType] = useState(announcementBarTabData.visibility_on_devices);
    const [visibilityOnDevicesDropdownOpen, setVisibilityOnDevicesDropdownOpen] = useState(false);
    const [barDisplaySchedule, setBarDisplaySchedule] = useState(Number(announcementBarTabData.is_bar_display_schedule));
    const [visitorClosedBar, setVisitorClosedBar] = useState(Number(announcementBarTabData.is_visitor_closed_bar));
    const [visitorClickedBar, setVisitorClickedBar] = useState(Number(announcementBarTabData.is_visitor_clicked_bar));
    const [jsTabCustomJs, setJsTabCustomJs] = useState(announcementBarTabData.custom_js);

    // Handlers Display Pages Change
    const handleDisplayPagesTypeChange = (event) => {
        const value = event.target.value;
        setDisplayPagesType(value);
        updateAnnouncementBarTabData("display_page_type", value);
    };

    // Handlers Hide Pages Change
    const handleHidePagesTypeChange = (event) => {
        const value = event.target.value;
        setHidePagesType(value);
        updateAnnouncementBarTabData("hide_page_type", value);
    };

    // Handlers Visibility On Devices Type Change
    const handleVisibilityOnDevicesTypeChange = (type) => {
        setVisibilityOnDevicesType(type);
        updateAnnouncementBarTabData(prev => ({
            ...prev,
            visibility_on_devices: type
        }));
        setVisibilityOnDevicesDropdownOpen(false);
    };

    //Handlers Is Bar Display Schedule On Change
    const handleBarDisplayScheduleChange = (e) => {
        const checked = e.target.checked;
        setBarDisplaySchedule(checked);
        updateAnnouncementBarTabData("is_bar_display_schedule", checked); 
    };

    //Handlers Is Visitor Closed ar On Change
    const handleVisitorClosedBarChange = (e) => {
        const checked = e.target.checked;
        setVisitorClosedBar(checked);
        updateAnnouncementBarTabData("is_visitor_closed_bar", checked); 
    };

    //Handlers Is Visitor Clicked Bar On Change
    const handleVisitorClickedBarChange = (e) => {
        const checked = e.target.checked;
        setVisitorClickedBar(checked);
        updateAnnouncementBarTabData("is_visitor_clicked_bar", checked); 
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateAnnouncementBarTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("pages")}>Pages <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("devices")}>Devices <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("schedule")}>Schedule <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                        <p>Adjust your bar's visibility for your website's pages and user devices. You can also set up a display schedule.</p>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("stop_display_for_visitor")}>Stop Display for Visitor <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                        <p>You can set up events, after which the bar will stop displaying to the visitor for a certain period of time once the visitor performs them.</p>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                        <p>Adjust your bar's visibility for your website's pages and user devices. You can also set up a display schedule.</p>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "pages" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Visibility on Pages
                        </span>
                        <div className="name-tile-row">Display On Pages</div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_pages" type="radio" name="display_pages" value="All_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'All_Pages'}  />
                                            <label for="display_pages">All Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="display_pages2" type="radio" name="display_pages"  value="Homepage" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'Homepage'}/>
                                            <label for="display_pages2">Homepage</label>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                        </div>
                        <div className="name-tile-row">Hide On Pages</div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="hide_pages" type="radio" name="hide_pages" value="None" onChange={handleHidePagesTypeChange} checked={hidePagesType === 'None'}  />
                                            <label for="hide_pages">None</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="hide_pages2" type="radio" name="hide_pages"  value="Homepage" onChange={handleHidePagesTypeChange} checked={hidePagesType === 'Homepage'}/>
                                            <label for="hide_pages2">Homepage</label>
                                        </div>
                                    </li>
                                </ul>
                            </div> 
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "devices" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Visibility on Devices
                        </span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Font</span>
                                <div className="color-pikr-box" onClick={() => setVisibilityOnDevicesDropdownOpen(!visibilityOnDevicesDropdownOpen)}>
                                    <em>{visibilityOnDevicesType}</em>
                                    {visibilityOnDevicesDropdownOpen && (
                                        <ul className="dropdown-list">
                                            {["All Devices","Desktop Only","Mobile Only"].map((font) => (
                                                <li key={font} onClick={() => handleVisibilityOnDevicesTypeChange(font)}>
                                                    {font}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div> 
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "schedule" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Schedule
                        </span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Bar Display Schedule </span>
                                <div className="form-group">
                                   <input id="open_is_bar_display_schedule" className="chkbx-toggle" type="checkbox" checked={barDisplaySchedule} onChange={handleBarDisplayScheduleChange} />
                                    <label for="open_is_bar_display_schedule"></label> 
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "stop_display_for_visitor" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("stop_display_for_visitor")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Stop Display for Visitor
                        </span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Visitor Closed Bar </span>
                                <div className="form-group">
                                   <input id="open_is_visito_closed_bar" className="chkbx-toggle" type="checkbox" checked={visitorClosedBar} onChange={handleVisitorClosedBarChange} />
                                    <label for="open_is_visito_closed_bar"></label> 
                                </div>
                                <p>Do not show the bar to the visitor for a certain time after they closed the bar by clicking on the close button.</p>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Visitor Clicked Bar </span>
                                <div className="form-group">
                                   <input id="open_is_visitor_clicked_bar" className="chkbx-toggle" type="checkbox" checked={visitorClickedBar} onChange={handleVisitorClickedBarChange} />
                                    <label for="open_is_visitor_clicked_bar"></label> 
                                </div>
                                <p>Do not show the bar to the visitor for a certain time after they clicked on the bar.</p>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;